import React from 'react';
import ComponentRegistry from "Fratello/Common/ComponentRegistry";
import { objectToQueryString } from "Fratello/Common/Utils";

export default function PanelView({ products, matrix, url, error, labels, onRemove }) {
    if (products.length === 0) {
        return null;
    }

    const ProductView = ComponentRegistry.get("ProductCompareViewsPanelProductView");

    const base = products[0].id;

    return (
        <div className="panel-compare collapse">
            { error != null && <div className="error-message">
                    <div className="container inner">{error}</div>
                </div> }
            <div className="container">
                <div className="row">
                    <div className="col-xs-6 col-xs-push-6 col-md-9 col-md-push-3">
                        <div className="actions">
                            <a className="btn-hide" onClick={function(e){
                                let compareBox = $('.panel-compare'),
                                    textHide = e.target.dataset.hide,
                                    textShow = e.target.dataset.show;
                                if(compareBox.hasClass('collapsed')) {
                                    compareBox
                                        .removeClass('collapsed')
                                        .addClass('collapse');
                                    $(e.target).find('.text').html(textShow);
                                } else {
                                    compareBox
                                        .removeClass('collapse')
                                        .addClass('collapsed');
                                    $(e.target).find('.text').html(textHide);
                                }
                            }} data-show={labels.show} data-hide={labels.hide} href="#"><span className="text">{labels.show}</span><i className="icon icon-arrow-down"></i></a>
                        </div>
                        <div className="compare-items row">
                            {products.map(product => <ProductView key={product.id} {...product} matrix={matrix[base][product.id]} onRemove={() => onRemove(product)} />)}
                        </div>
                    </div>
                    <div className="col-xs-6 col-xs-pull-6 col-md-3 col-md-pull-9">
                        <h2>{labels.title}</h2>
                        <section className="aside-content">{labels.description}</section>
                        {/* No SKU available in Array, so I used product.id */}
                        <a href={url+"?"+objectToQueryString({products: products.map(product => product.sku)})} className="btn btn-primary btn-sm">{labels.compare}</a>
                    </div>
                </div>
            </div>
        </div>
    );
}




// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductCompare/Views/PanelView.jsx